var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[_c('navbar'),_c('ribbon'),_c('div',{staticClass:"container-fluid main-container",class:_vm.additionalFooterClass},[_c('router-view')],1),_c('FloatingMenu'),(_vm.authorizedUser)?_c('conversation-list'):_vm._e(),_c('footer-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }